import * as React from 'react';
import { useSelector } from 'react-redux';

import { AgentsOffersRow } from '../../components/AgentsOffersRow';
import { OffersFooter } from '../../components/OffersFooter';
import { OffersList, OffersRow } from '../../components/OffersListAB';
import { selectDefaultProductsData } from '../../selectors/analytics';
import { getSelectedHouseId, getSelectedHouseOffers, isHouseNameVisible } from '../../selectors/offers';
import {
  trackAgentFlatsLinkClick,
  trackAllFlatsLinkClick,
  trackOffersQuantityLinkClick,
  trackRoomTypeLinkClick,
} from './tracking';

export function OffersContainer() {
  const offers = useSelector(getSelectedHouseOffers);
  const displayHouseName = useSelector(isHouseNameVisible);
  const isHouseSelected = Boolean(useSelector(getSelectedHouseId));
  const product = useSelector(selectDefaultProductsData);

  const onOffersQuantityLinkClick = React.useCallback(
    roomType => {
      trackOffersQuantityLinkClick(product, roomType);
    },
    [product],
  );

  if (!offers) {
    return null;
  }

  const { fromAgentsPropsCountDisplay, fromAgentsPropsCountUrl, propsCountDisplay, propsCountUrl, fromDeveloperRooms } =
    offers;

  if (fromDeveloperRooms.length > 0) {
    return (
      <>
        <OffersList>
          {fromDeveloperRooms.map(flatTypeBlock => (
            <OffersRow
              key={flatTypeBlock.roomTypeDisplay}
              {...flatTypeBlock}
              displayHouseName={displayHouseName}
              onRoomTypeLinkClick={trackRoomTypeLinkClick}
              onOffersQuantityLinkClick={onOffersQuantityLinkClick}
            />
          ))}
        </OffersList>
        <OffersFooter
          fromAgentsPropsCountDisplay={fromAgentsPropsCountDisplay}
          fromAgentsPropsCountUrl={fromAgentsPropsCountUrl}
          propsCountDisplay={propsCountDisplay}
          propsCountUrl={propsCountUrl}
          isHouseSelected={isHouseSelected}
          onAgentOffersLinkClick={trackAgentFlatsLinkClick}
          onAllOffersLinkClick={trackAllFlatsLinkClick}
        />
      </>
    );
  }

  return (
    <AgentsOffersRow
      fromAgentsPropsCountDisplay={fromAgentsPropsCountDisplay}
      fromAgentsPropsCountUrl={fromAgentsPropsCountUrl}
    />
  );
}
